<template>
  <section>
    <div class="mt-4">
      <div class="flex mr-4 text-blue cursor-pointer" @click="downloadTemplate">
        <b-icon pack="fas" icon="file-excel"></b-icon>
        {{ $t('download_template') }}
      </div>
      <template>
        <section>
          <b-modal v-model="downloadModal" title="Descargar plantilla de importación de tareas" :width="300">
            <div class="flex flex-col bg-white p-4 rounded-lg" >
              <div class="flex items center">
                <span class="text-blue md:text-lg font-bold">{{$t('select_template')}}</span>
              </div>
              <div class="border-b border-gray-300 mt-4"></div>
              <div class="flex flex-col mt-4" v-for="(file, index) in filteredFiles" :key="index">
                <div class="flex items-center cursor-pointer mt-2
                " @click="downloadTemplateByName(file.filename)">
                  <b-icon pack="fas" icon="file-excel" class="mr-2 text-blue"></b-icon>
                  <span class="text-blue"
                  >{{ file.name }}</span>
                </div>
              </div>
            </div>
          </b-modal>
        </section>
      </template>
      <div class="panel">
        <form @submit.prevent="submitForm" :files="true">
          <div class="flex w-full">
            <div class="flex">
              <b-field class="flex mr-4">
                <b-upload v-model="form.excelFile" @input="cleanErrors" required
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                  <a class="button is-primary">
                    <b-icon pack="fas" icon="upload"></b-icon>
                    <span>{{ $t('select_file') }}</span>
                  </a>
                </b-upload>
                <span class="file-name" v-if="form.excelFile">{{ form.excelFile.name }}</span>
              </b-field>
            </div>
            <div class="flex" v-if="entityType == 'activity-groups'">
              <b-field class="mr-4">
                <b-select v-model="form.activityGroupImportType" size="is-small" rounded icon="file" :required="true">
                  <option value="groups">{{ $t('groups') }}</option>
                  <option value="budgets">{{ $t('budgets') }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="flex" v-if="entityType == 'assignment'">
              <b-field class="mr-2">
                <b-select v-model="form.assignmentType" size="is-small" rounded icon="file" :required="true">
                  <option value="task">Tareas</option>
                  <option value="resources_bc3">Recursos (BC3)</option>
                  <option value="certifiers">Certificadoras</option>
                  <option value="resources_bcs">Simple</option> <!-- para importar mediciones plantilla simple -->
                  <option value="resources_breakdown">Simple Descompuesto</option>
                  <option value="chapters">Capítulos</option> <!-- para importar capítulos -->
                  <option value="certifiers-chapters">Capítulos con partidas</option>
                  <!-- para importar capítulos con certificadoras dentro -->
                </b-select>
              </b-field>
            </div>
            <div class="flex" v-if="entityType == 'expected_executions'">
              <b-field class="mr-2">
                <b-select v-model="form.workType" size="is-small" rounded icon="file" :required="true">
                  <option value="0" v-if="actionType != 'economic_programming'">Tuberias</option>
                  <option value="2" v-if="actionType != 'economic_programming'">Economico Ejecutado</option>
                  <option value="3" v-if="actionType != 'economic_programming'">Economico Redactado</option>
                  <option value="4" v-if="actionType != 'economic_programming'">Ejecutado Mínimo (6m)</option>
                  <option value="5" v-if="actionType != 'economic_programming'">Redactado Mínimo (3m)</option>
                  <option value="6" v-if="actionType != 'economic_programming'">Economico Ejecutado DSO</option>
                  <option value="7" v-if="actionType != 'economic_programming'">Hitos Ejecutado</option>
                  <option value="8" v-if="actionType != 'economic_programming'">Hitos Redactado</option>
                  <option value="9" v-if="actionType == 'economic_programming'">Programación económica ventas</option>
                  <option value="10" v-if="actionType == 'economic_programming'">Programación económica planificada</option>
                  <option value="11" v-if="actionType != 'economic_programming' && isEag">{{ $t('initial_final_planning') }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="flex" v-if="overwriteEnabled">
              <v-switch v-model="form.overwrite" ref="form_overwrite" :label="$t('allow_to_overwrite')"
                :color="form.overwrite ? 'green' : 'red'" class="mr-1"
                v-on:checked="(value) => form.overwrite = value" />
            </div>
            <div class="flex ml-4">
              <slot name="descripcion"></slot>
            </div>
          </div>
          <!-- fragmento provisional. Lotes canal cargas anteriores -->
          <div class="flex w-full mt-4 mb-0" v-if="form.assignmentType == 'task'">
            <div class="flex w-full">
              (Fecha efectiva: Solo admin Epc-tracker)
            </div>
            <div class="flex w-full">
              <b-field class="w-full">
                <b-datepicker icon="calendar" icon-pack="fas" type="month" v-model="effectiveDate" :placeholder="'fecha efectiva'"
                  :month-names="$t('months_names')" :day-names="$t('days_names')"
                  :first-day-of-week="parseInt($t('first_day_of_week'))" :readonly="false" :max-date="previousMonth">
                </b-datepicker>
              </b-field>
            </div>
          </div>
          <!-- fin fragmento provisional -->

          <!-- IMPORTANDO MEDICIONES. Linea para busqueda actividad y fecha efectiva -->
          <div class="flex w-full mt-4 mb-0"
            v-if="form.assignmentType == 'certifiers' || form.assignmentType == 'chapters' || form.assignmentType == 'certifiers-chapters'">
            <div class="flex w-full">
              <b-field class="w-full">
                <b-autocomplete required :placeholder="$t('planning_code') + ' ' + $t('activity')"
                  v-model="form.activityCode" minlength="3" maxlength="255" expanded :disabled="disableActivityCode"
                  :data="filteredActivities" @input="getFilteredActivities">
                </b-autocomplete>
              </b-field>
            </div>
            <div class="flex w-full">
              <b-field class="w-full">
                <b-datepicker icon="calendar" icon-pack="fas" type="month" v-model="effectiveDate" :placeholder="'fecha efectiva'"
                  :month-names="$t('months_names')" :day-names="$t('days_names')"
                  :first-day-of-week="parseInt($t('first_day_of_week'))" :readonly="false" :max-date="previousMonth">
                </b-datepicker>
              </b-field>
            </div>
          </div>

          <!-- IMPORTANDO PLANIFICACION DE AVANCES. Linea para busqueda actividad, solo para el caso especial 'Economico Ejecutado DSO' -->
          <div class="flex w-full mt-4 mb-0"
            v-if="form.workType == 6">
            <div class="flex w-full">
              <b-field class="w-full">
                <b-autocomplete required :placeholder="$t('planning_code') + ' ' + $t('activity')"
                  v-model="form.activityCode" minlength="3" maxlength="255" expanded :disabled="disableActivityCode"
                  :data="filteredActivities" @input="getFilteredActivities">
                </b-autocomplete>
              </b-field>
            </div>
          </div>

          <!-- IMPORTANDO LINEA BASE. Capitulo etiqueta nivel 3 -->
          <div class="flex w-full mt-4 mb-0" v-if="isBaselineWorkType">
            <b-field class="w-1/3 mr-2">
              <b-select v-model="baselineLevel1Id" :placeholder="$t('discipline')" :loading="isLoadingChapters" required expanded
                @input="baselineLevel2Id = null; baselineChapterId = null">
                <option v-for="chapter in baselineChapters" :key="chapter.id" :value="chapter.id">{{ chapterLabel(chapter) }}</option>
              </b-select>
            </b-field>
            <b-field class="w-1/3 mr-2" v-if="baselineLevel1Id">
              <b-select v-model="baselineLevel2Id" :placeholder="$t('tag_chapters_level_2')" required expanded
                @input="baselineChapterId = null">
                <option v-for="chapter in baselineLevel2Options" :key="chapter.id" :value="chapter.id">{{ chapterLabel(chapter) }}</option>
              </b-select>
            </b-field>
            <b-field class="w-1/3" v-if="baselineLevel2Id">
              <b-select v-model="baselineChapterId" :placeholder="$t('tag_chapters_level_3')" required expanded>
                <option v-for="chapter in baselineLevel3Options" :key="chapter.id" :value="chapter.id">{{ chapterLabel(chapter) }}</option>
              </b-select>
            </b-field>
          </div>

          <!-- input de descripcion -->
          <div class="flex w-full mt-4">
            <div class="flex w-full">
              <b-field class="w-full">
                <b-input required :placeholder="$t('description')" v-model="form.description" maxlength="255"
                  expanded></b-input>
              </b-field>
            </div>
          </div>

          <div class="flex w-full mb-4" v-if="entityType == 'activity-groups' && form.activityGroupImportType === 'budgets'">
            <div class="flex w-full">
              <b-field class="w-full">
                <b-input v-model="form.budgetCodePrefix" :placeholder="$t('p6_code_prefix_placeholder')"
                  expanded></b-input>
              </b-field>
            </div>
          </div>

          <div class="flex w-full">
            <v-button :loading="isLoading" type="submit" color="green" icon="file-import" icon-pack="fas">{{
              $t('import') }}</v-button>
          </div>
        </form>
      </div>
      <div>
        <b-tabs type="is-boxed" v-model="importActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="box-open"></b-icon>
              <span>{{ $t('imports_archive') }}</span>
            </template>
            <div>
              <entity-imports-archive v-if="withHistory" :project-id="projectId" :partner-id="partnerId"
                :company-id="companyId" :entity-type="entityType" :overwrite-field="true" :per-page="perPage"
                :type="form.historyType" :action-type="actionType"
                ref="entity_imports"></entity-imports-archive>
            </div>
          </b-tab-item>

          <b-tab-item :disabled="errors.length < 1">
            <template slot="header">
              <b-icon pack="fas" icon="exclamation-circle"></b-icon>
              <span>
                {{ $t('error_log') }}
                <b-tag rounded>{{ errorsCount }}</b-tag>
              </span>
            </template>
            <div>
              <div class="flex items-center font-bold text-red-dark text-ml mb-4">
                <span>{{ $t('error_import_title') }}</span>
              </div>
              <div v-for="(error, index) in errors" :key="'error_' + index">
                <ul>
                  <li v-for="(msg, index) in error.messages" :key="'errorli_' + index" class="menu-header mb-2">
                    <div class="flex items-center">
                      <div class="text-red-dark text-ml">
                        <span>
                          {{ $t('import_row_title', [error.row]) }}.
                          {{ msg }}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </b-tab-item>

          <b-tab-item v-if="warnings && warnings.length > 0">
            <template slot="header">
              <b-icon pack="fas" icon="exclamation-triangle"></b-icon>
              <span>
                {{ $t('warning') }}
                <b-tag rounded>{{ warnings.length }}</b-tag>
              </span>
            </template>
            <div>
              <div class="flex items-center font-bold text-orange text-ml mb-4">
                <span>{{ $t('warning') }}</span>
              </div>
              <div v-for="(msg, index) in warnings" :key="'warning_' + index">
                <ul>
                  <li class="menu-header mb-2">
                    <div class="flex items-center">
                      <div class="text-orange text-ml">
                        <span>{{ msg }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import Form from "vform";
import entityImportsArchive from "./entity-imports-archive";

import axios from 'axios';
import * as XLSX from 'xlsx';
import { mapGetters } from 'vuex';
import moment from "moment";

export default {
  name: "import-entities",
  components: {
    entityImportsArchive,
  },

  props: {
    withHistory: { type: Boolean, default: true },
    projectId: { type: Number, default: null, required: false },
    partnerId: { type: Number, default: null, required: false },
    companyId: { type: Number, default: null, required: false },
    entityId: { type: String, default: '', required: false }, // mediciones certificadoras van sobre una actividad concreta
    entityType: { type: String, required: true },
    canOverwrite: { type: Boolean, default: false },
    actionType: { type: String, default: '' }, // distinciones a tener en cuenta por el importador
    morphType: { type: String, default: '' }, // usado para cuando se tenga que trabajar con importaciones polimorphicas
    assignmentType: { type: String, default: null }, // para cargar certificadoras se requiere que por defecto sea seleccionado
    chapterId: { type: Number, default: null }, // capitulo preseleccionado (linea base)
    perPage: { type: Number, required: false, default: 20 }
  },

  created() {
    // si pasamos un codigo actividad, para importar cantidades ejecutadas sobre una medicion (desde la modal)
    if (this.entityId !== '') {
      this.form.activityCode = this.entityId
      this.form.overwrite = 1 // para cargar cantidades ejecutadas se requiere esta opcion a true
      this.form.assignmentType = this.assignmentType
      this.disableActivityCode = true,
      this.form.historyType = this.assignmentType
    }
    // Para importaciones de cantidad ejecutada, filtrar historial solo por ese tipo
    if (this.entityType === 'assignments-executedquantity') {
      this.form.historyType = "15" // import_executedquantity. Espera valor tipo string
    }
    this.files = [
      // Plantillas para assignments-executedquantity
      { filename: "template_import_assignments-executedquantity.xlsx", entityType: "assignments-executedquantity", name: this.$t('simple') },
      { filename: "template_import_assignment_decomposed_resource.xlsx", entityType: "assignments-executedquantity", name: this.$t('resources_breakdown') },
       // Plantillas para assignments
      { filename: "template_import_recursos_(BC3).xlsx", entityType: "assignment", name: this.$t('resources_bc3') },
      { filename: "template_import_mediciones_Simple.xlsx", entityType: "assignment", name: this.$t('simple') },
      { filename: "template_import_resources_breakdown.xlsx", entityType: "assignment", name: this.$t('resources_breakdown') }
    ];
  },

  data: () => ({
    isLoading: false,
    form: new Form({
      projectId: null,
      partnerId: null,
      companyId: null,
      excelFile: null,
      description: "",
      overwrite: false,
      assignmentType: null,
      activityGroupImportType: 'groups', // para entityType 'activity-groups': 'groups' | 'budgets'
      budgetCodePrefix: '',
      activityCode: null,
      actionType: "", // import, certificateQuantity.
      workType: null,
      effectiveDate: "",
      historyType: null,
      warnings: [],
    }),
    files: [],
    downloadModal: false,
    effectiveDate: null,
    errors: [],
    warnings: [],
    importActiveTab: 0,
    errorsCount: 0,
    disableActivityCode: false,
    filteredActivities: [],
    baselineLevel1Id: null,
    baselineLevel2Id: null,
    baselineChapterId: null,
    baselineChapters: [], // arbol de capitulos etiqueta
    isLoadingChapters: false,
  }),

  watch: {
    // observamos el worktype para aumentar el type de la importacion
    'form.workType': function (newVal) {
      this.form.historyType = newVal
      if (this.isBaselineWorkType) {
        this.form.overwrite = false // linea base no sobrescribe
        this.getBaselineChapters()
      }
    },

    // cambio de proyecto: recargar arbol
    projectId() {
      this.baselineChapters = []
      this.baselineLevel1Id = null
      this.baselineLevel2Id = null
      this.baselineChapterId = null
      if (this.isBaselineWorkType) this.getBaselineChapters()
    },

    // capitulo preseleccionado: tipo linea base
    chapterId: {
      immediate: true,
      handler(value) {
        if (!value) return
        if (!this.isBaselineWorkType) this.form.workType = "11"
        this.baselineChapterId = value
        // no esta en el arbol: recargar
        if (!this.selectBaselinePath() && this.baselineChapters.length) this.getBaselineChapters(true)
      }
    },

    // observamos el assignmentType para aumentar el type de la importacion
    'form.assignmentType': function (newVal) {
      this.form.historyType = newVal

    }
  },

  computed: {
    ...mapGetters({
      company: 'app/company',
    }),
    // linea base: solo EAG
    isEag() {
      return this.company && this.company.alias === 'eag';
    },
    templateName() {
      // TODO: de momento hacemos este hack para mantener funcionando (replace('/', '-')) lo ideal es quitar el replace y mantener una convencion para entitytype
      let filename = "template_import_" + this.entityType.replace('/', '-') + ".xlsx";
      if (this.entityType === 'activity-groups' && this.form.activityGroupImportType === 'budgets') {
        filename = "template_import_activity-groups-budgets.xlsx";
      }
      return this.assetVapor(filename);
    },
    templateFileName() {
      // TODO: de momento hacemos este hack para mantener funcionando (replace('/', '-'))
      if (this.entityType === 'activity-groups' && this.form.activityGroupImportType === 'budgets') {
        return "template_import_activity-groups-budgets.xlsx";
      }
      return this.$t(this.entityType.replace('/', '-') + "_import_template") + ".xlsx";
    },
    overwriteEnabled() {
      // linea base siempre sustituye
      return this.canOverwrite && !this.isBaselineWorkType;
    },
    baselineLevel2Options() {
      const level1 = this.baselineChapters.find(chapter => chapter.id === this.baselineLevel1Id)
      return level1 ? level1.children || [] : []
    },
    baselineLevel3Options() {
      const level2 = this.baselineLevel2Options.find(chapter => chapter.id === this.baselineLevel2Id)
      return level2 ? (level2.children || []).filter(chapter => chapter.level == 3) : []
    },
    isBaselineWorkType() {
      return this.entityType == 'expected_executions' && String(this.form.workType) === '11';
    },
    previousMonth() {
      let today = new Date()
      return new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
    },
    filteredFiles() {
      return this.files.filter(f => f.entityType === this.entityType);
    }
  },

  methods: {
    submitForm() {
      this.isLoading = true;
      var self = this;
      this.cleanErrors();

      this.form.projectId = this.projectId;
      this.form.partnerId = this.partnerId;
      this.form.companyId = this.companyId;
      this.form.actionType = this.actionType;
      if (this.isBaselineWorkType)
        this.form.chapterId = this.baselineChapterId
      this.form.effectiveDate = this.effectiveDate
        ? moment(this.effectiveDate).format('YYYY-MM-DD')
        : "";
      if (this.morphType)
        this.form.morphType = this.morphType
      this.form
        .post("/api/v2/import/" + this.entityType)
        .then(function (response) {

          self.isLoading = false;
          if (response.data.success) {
            self.$notify.success("success_import");
            self.warnings = Array.isArray(response.data.warnings) ? response.data.warnings : [];
            self.form.description = "";
            if (self.withHistory)
              self.$refs.entity_imports.reloadImports();

            self.$nextTick(() => {
              self.importActiveTab = self.warnings.length > 0 ? 2 : 0;
            self.$emit("success");
            });
          } else {

            self.$notify.error("error_import");

            // Procesamos los errores para mostrarlos
            for (let key in response.data.errors) {
              let error_info = key.split(".");
              let row = parseInt(error_info[0]);
              let field = `[${error_info[1]}]`;//self.$t(error_info[1]);

              let messages = response.data.errors[key].map(function (msg) {
                return self.$t(msg) !== msg
                  ? self.$t(msg, [field])
                  : msg; // prefiero el msg tal cual se devuelve en el importador
                // : self.$t("import_generic_error_msg", [parseInt(field)+1]); // mensaje generico sin muchas pistas
              });

              self.errorsCount = self.errorsCount + messages.length;

              self.errors.push({ row: row, field: field, messages: messages });
            }

            self.errors = self.errors.sort(function (a, b) {
              return parseInt(a.row) - parseInt(b.row);
            });

            self.importActiveTab = 1;
            self.warnings = [];
          }
        })
        .catch(error => {
          self.isLoading = false;
          self.$notify.error("error_import");
        });

      this.form.excelFile = null;
    },

    cleanErrors() {
      this.errors = [];
      this.errorsCount = 0;
      this.importActiveTab = 0;
    },
    downloadTemplateByName(filename) {
      let link = document.createElement("a");
      link.href = this.assetVapor(filename);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    },
    downloadTemplate() {
      if (this.isBaselineWorkType) {
        this.downloadBaselineTemplate();
        return;
      }
      if (this.entityType == 'assignment' || this.entityType == 'assignments-executedquantity') {
        this.downloadModal = true;
        return;
      }
      let link = document.createElement("a");
      link.href = this.templateName;
      link.download = this.templateFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // plantilla vacia con cabeceras traducidas
    downloadBaselineTemplate() {
      const worksheet = XLSX.utils.aoa_to_sheet([
        [this.$t('accumulated')],
        [this.$t('date'), this.$t('original_planning'), this.$t('latest_planning')],
      ]);
      worksheet['!cols'] = [{ wch: 20 }, { wch: 25 }, { wch: 25 }];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.$t('accumulated'));
      XLSX.writeFile(workbook, "template_import_expected_executions_baseline.xlsx");
    },

    chapterLabel(chapter) {
      return (chapter.code ? chapter.code + ' ' : '') + chapter.name
    },

    // arbol de capitulos etiqueta con nivel 3
    async getBaselineChapters(force = false) {
      if ((this.baselineChapters.length && !force) || this.isLoadingChapters) return
      this.isLoadingChapters = true
      try {
        const { data } = await axios.get(`/api/v2/project/${this.projectId}/tag-chapters/tree`)
        this.baselineChapters = data && data.success ? this.pruneTagTree(data.chapters) : []
        this.selectBaselinePath()
      } catch (e) {
        this.$notify.error('error_loading_data')
      } finally {
        this.isLoadingChapters = false
      }
    },

    // quita ramas sin nivel 3
    pruneTagTree(nodes) {
      return nodes
        .map(node => node.level == 3 ? node : { ...node, children: this.pruneTagTree(node.children || []) })
        .filter(node => node.level == 3 || node.children.length)
    },

    // selecciona nivel 1 y 2 del capitulo
    selectBaselinePath() {
      if (!this.baselineChapterId) return false
      let found = false
      this.baselineChapters.forEach(level1 => {
        (level1.children || []).forEach(level2 => {
          if ((level2.children || []).some(level3 => level3.id === this.baselineChapterId)) {
            this.baselineLevel1Id = level1.id
            this.baselineLevel2Id = level2.id
            found = true
          }
        })
      })
      return found
    },

    async getFilteredActivities() {
      if (this.form.activityCode && this.form.activityCode.length > 2) {
        let getParams = {
          p: this.projectId,
          filter_planning_code: this.form.activityCode,
          light: 1
        }
        const { data } = await axios.get('/api/v2/activities', { params: getParams });
        this.filteredActivities = data.activities.map(activity => activity.planning_code);
      }

      else {
        this.filteredActivities = [];
      }
    },
  }
};
</script>
